var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00042 9.25628C6.65871 9.59799 6.65871 10.152 7.00042 10.4937L12.0004 15.4937L17.0004 10.4937C17.3421 10.152 17.3421 9.59799 17.0004 9.25628C16.6587 8.91457 16.1047 8.91457 15.763 9.25628L12.0004 13.0188L8.23786 9.25628C7.89615 8.91457 7.34213 8.91457 7.00042 9.25628Z",
    fill: "#8082C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownTransparent);
export default __webpack_public_path__ + "static/media/arrowDownTransparent.6acdd46ecd5b5e718840d542c0d7bc71.svg";
export { ForwardRef as ReactComponent };